export const PRICE_INDEX_API_BASE_PATH = "/api/v1/price-index";
export const PRICE_INDEX_API_MCP_PATH = `${PRICE_INDEX_API_BASE_PATH}/mcp`;
export const PRICE_INDEX_API_OPENAPI_PATH = `${PRICE_INDEX_API_BASE_PATH}/openapi.json`;
export const PRICE_INDEX_API_DOCS_PATH = "/price-index/api";

export const PRICE_INDEX_API_KEY_HEADER = "X-API-Key";
export const PRICE_INDEX_API_KEY_PREFIX = "rpk_pi_";
export const MAX_ACTIVE_PRICE_INDEX_API_KEYS = 10;

export const PRICE_INDEX_API_ACCESS = ["open", "key"] as const;
export type PriceIndexApiAccess = (typeof PRICE_INDEX_API_ACCESS)[number];

export const PRICE_INDEX_API_TIERS = ["open", "free", "pro"] as const;
export type PriceIndexApiTier = (typeof PRICE_INDEX_API_TIERS)[number];

export const PRICE_INDEX_API_ERROR_CODES = [
  "invalid_parameters",
  "not_found",
  "invalid_api_key",
  "api_key_required",
  "rate_limited",
] as const;
export type PriceIndexApiErrorCode = (typeof PRICE_INDEX_API_ERROR_CODES)[number];

export const PRICE_INDEX_API_KEY_LAST_USED_REFRESH_MS = 60 * 60 * 1000;

export const PRICE_INDEX_API_LIMITS = {
  openPerMinute: 60,
  freePerDay: 1000,
  keyPerMinute: 300,
} as const;

export const PRICE_INDEX_API_ATTRIBUTION_TEXT = "Price data by Repackify";

export function priceIndexPagePath(scope: {
  productTypeSlug: string;
  stateSlug?: string;
  citySlug?: string;
}): string {
  return ["/price-index", scope.productTypeSlug, scope.stateSlug, scope.citySlug]
    .filter(Boolean)
    .join("/");
}
